export const site_primary_function = {
  state: {
    site_primary_functions: []
  },
  mutations: {
    updateSitePrimaryFunctions: function(state, newList) {
      state.site_primary_functions = newList;
    }
  },
  getters: {
    getAllSitePrimaryFunctions(state) {
      return state.site_primary_functions;
    }
  }
}